









































































































































































































































































































































































































































































































































































































































































































































    import { Component, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	import ReceiverDetailBase from "./ReceiverDetailBase";

	@Component
	export default class ReceiverDetail extends ReceiverDetailBase {

		showErrorConnectionState() {
			return this.formData.connectionStateError ? "red" : "";
		}

		showPlayButton() {
            return this.formData.idComponentStateNavigationIdentifier == "ENU_COR_Component_State_Idle" && (this.formData.taskPriority != null || this.formData.taskCommon != null || this.formData.taskIdle != null);
		}

		descriptionName() {
			return this.notAssigned == true ? this.$t('receiverDetail.assignedReceiverName').toString() + this.formData.name : this.$t('receiverDetail.description').toString();
		}

		play() {
			this.playBase();
		}

        showButtonMessageHistory() {
            return RightHelper.currentUserHasRight('COR_Message_Read');
        }

        showRemoveItemButton() {
            return RightHelper.currentUserHasRight('COR_Message_Update');
        }

        allowRemoveItemHistory() {
            return true;
		}

		removeItem:any;
        removeHistoryItemMessage(item: any) {
			this.removeItem = item;
            this.showAlertModalById("idRemoveMessage");
        }

		removeHistoryItem(item: any) {
			item = this.removeItem;
            this.cancelComponentMessage(item);
        }

		showParams(show: boolean) {
			this.showParamsDetail = !show;
		}

		showResetButton() {
			return RightHelper.currentUserHasRight('CON_Receiver_Update') && this.formIsInEditMode == false;
		}

        refreshClick() {
            this.refreshClickBase();
        }

        resetClick() {
            this.showAlertModalById("alertModalIdReset");
        }

        softResetClick() {
            this.showAlertModalById("alertModalIdSoftReset");
        }

		reset() {
			this.resetBase();
		}

		softReset() {
			this.softResetBase();
		}

  
		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}		

		////TODO tohle je i v baseTlTalbe - sjednotit
		changeTags(items: any): void {
			this.changeTagsBase(items);
		}

		goBackDetailTag(item: any): void {
			this.goBackDetailTagBase(item);
		}

		assignTenant() {
			this.assignTenantBase();
		}

		selectedTenantItems(items: any): void {
			this.selectedTenantItemsBase(items);
		}

		created() {
            this.notAssigned = this.$store.state.notAssigned;
			super.initializeRights(undefined, 'CON_Receiver_Delete', 'CON_Receiver_Read', 'CON_Receiver_Update');
			super.setMainDescription('receiver.new', 'receiver.detail');
			super.setTimer(this.$store.state.pageTimer);
			this.createdBase();
            this.mainDataChanged = false;
		}

		gotoTask(item: any) {		
            this.$router.push({ name: 'TaskDetail', params: { id: item.id }, query: { id: item.id } });
		}

		gotoMedia(item: any) {
            this.$router.push({ name: 'ContentDetail', params: { id: item.id }, query: { id: item.id } });
		}

		goToEditTags(): void {
			this.$router.push({ name: 'TagList', params: { returnRoute: 'TODOcesaZpet' } });
		}

		showAdoptionCode() {
			return this.showAdoptionCodeBase();
		}

		mounted() {
			this.fetchVariantList();
			//TODO tohle na pozadavek 410 
			//this.fetchContentImageList();
			
            this.timerHandle = setInterval(() => {
                this.timerRefresh();
			}, this.timerSecondRefresh);
			super.mounted();
            window.scrollTo(0, 0); 
		}

		
		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		isCorrectComponentId(value: any) {
			this.isCorrectComponentIdBase(value);
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && (this.mainDataChanged || this.mainDataChangedSub)) {
                event.preventDefault(); event.returnValue = "";
            }
        }
      
        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

       
        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
			this.$store.commit("mainDataChanged", false);
            clearInterval(this.timerHandle);
        }
	}
